module.exports = __webpack_public_path__ + "media/images/close-button-509c9d7ef3ac73500f0342979dd977e8.png";